import {ReactNode} from 'react';

import {Box, Grid, Typography} from '@mui/material';

interface Props {
  label: string;
  value: ReactNode;
}

export const BatchInvitationDetailsInfoRow = ({label, value}: Props) => (
  <Grid item xs={12} sm={6}>
    <Typography variant='body2' sx={{fontWeight: 700}}>
      {label}
    </Typography>
    <Box marginTop='2px'>{value}</Box>
  </Grid>
);
